import React, { useContext, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { DynamicModuleLoader } from 'redux-dynamic-modules-react';
import getRootModule from 'RootModule';
import getPOGMassiveUploadModule from '../getPOGMassiveUploadModule';
import { layoutContext } from 'context';
import { useHistory } from 'react-router-dom';
import { Form } from 'antd';
import {
  MassiveUploadTable,
  UploadExcelButton,
  ActionButtonsExcelUpload,
} from 'common/MassiveUploads/components';
import { triggerModalForDuplicates } from 'common/MassiveUploads/utils';
//cambiar sagas
import {
  POGMassiveUploadSetAllowUpload,
  POGMassiveUploadRequestVerify,
  POGMassiveUploadRequestUpload,
  POGMassiveUploadClearUpload,
  POGMassiveUploadClearVerify,
  POGMassiveUploadClearAllowUpload,
} from '../redux-saga/actions';
import tableColumns from '../schemas/massiveUploadTableColumns'; //cambiar columna

const POGMassiveUpload = (props) => {
  const {
    POGMassiveUploadSetAllowUpload: setAllowUpload,
    POGMassiveUploadRequestVerify: requestVerify,
    POGMassiveUploadRequestUpload: requestUpload,
    POGMassiveUploadClearUpload: clearUpload,
    POGMassiveUploadClearVerify: clearVerify,
    POGMassiveUploadClearAllowUpload: clearAllowUpload,
    allowUpload,
    verify,
  } = props;

  const history = useHistory();
  const [form] = Form.useForm();
  const { onChangeActiveComponent } = useContext(layoutContext);
  const [fileString, setFileString] = useState('');
  // const [disabledButton, setDisabledButton] = useState(false);
  const correct = verify?.correct;
  const entriesList = verify?.objectList;
  const totalDuplicatedEntries = verify?.replaced?.length;
  const allCorrectMessage = verify?.allCorrectMessage;

  useEffect(() => {
    clearAllowUpload();
    return () => {
      clearAllowUpload();
      clearUpload();
      clearVerify();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    onChangeActiveComponent('activo');
    if (correct > 0) {
      setAllowUpload(true);
    } else {
      setAllowUpload(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [correct]);

  function customRequest({ file }) {
    requestVerify({ file, setFileString });
    // setDisabledButton(true);
  }
  function requestReplace() {
    requestUpload({ history, fileString, overwrite: true });
  }
  function requestKeep() {
    requestUpload({ history, fileString, overwrite: false });
  }
  function onSubmit() {
    if (totalDuplicatedEntries > 0) {
      triggerModalForDuplicates(totalDuplicatedEntries, requestReplace, requestKeep, 'Ventas');
      return;
    }

    requestReplace();
  }
  function onCancel() {
    history.push(`/historic-information`);
  }

  return (
    <Form form={form}>
      <UploadExcelButton customRequest={customRequest} />
      <MassiveUploadTable
        data={entriesList}
        columns={tableColumns}
        allCorrectMessage={allCorrectMessage}
      />
      <ActionButtonsExcelUpload
        onSubmit={onSubmit}
        onCancel={onCancel}
        disabled={!allowUpload}
        buttons={['cancel', 'submit']}
      />
    </Form>
  );
};

const mapStateToProps = (state) => {
  return {
    allowUpload: state?.POG_MASSIVE_UPLOAD?.allowUpload,
    verify: state?.POG_MASSIVE_UPLOAD?.verify,
  };
};

const ConnectedPOGMassiveUpload = connect(mapStateToProps, {
  POGMassiveUploadSetAllowUpload,
  POGMassiveUploadRequestVerify,
  POGMassiveUploadRequestUpload,
  POGMassiveUploadClearUpload,
  POGMassiveUploadClearVerify,
  POGMassiveUploadClearAllowUpload,
})(POGMassiveUpload);

const POGMassiveUploadWithModules = () => {
  return (
    <DynamicModuleLoader modules={[getRootModule(), getPOGMassiveUploadModule()]}>
      <ConnectedPOGMassiveUpload />
    </DynamicModuleLoader>
  );
};
export default POGMassiveUploadWithModules;
